const NAMESPACE = "projectInquiriesCapsule";

const KEYS = {
    projectInquiriesCapsuleTitle: "projectInquiriesCapsuleTitle",
    openThreadsLabel: "openThreadsLabel",
    closedThreadsLabel: "closedThreadsLabel",
    noInquiriesLabel: "noInquiriesLabel",
    selectInquiryLabel: "selectInquiryLabel"
};

const MESSAGES = {
    [KEYS.projectInquiriesCapsuleTitle]: {
        value: "{buttonText} Threads",
        comment: "Title for the project inquiries capsule"
    },
    [KEYS.openThreadsLabel]: {
        value: "Open Threads",
        comment: "Text for open threads"
    },
    [KEYS.closedThreadsLabel]: {
        value: "Closed Threads",
        comment: "Text for closed threads"
    },
    [KEYS.noInquiriesLabel]: {
        value: "This project has no inquiries.",
        comment: "Text to display to user if there are zero inquiries on project"
    },
    [KEYS.selectInquiryLabel]: {
        value: "Select Inquiry:",
        comment: "Label for the select inquiry dropdown"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
